import React, { useState, useEffect, Fragment } from 'react'
import { object, node, bool, func, string, number } from 'prop-types'
import SwiperCore, { Virtual } from 'swiper'
import { Swiper } from 'swiper/react'
import classnames from 'classnames'
/* eslint-disable-next-line max-len */
import { swiperConfig, swiperLazyConfig, swiperAutoViewConfig, renderPrevButton, renderNextButton, virtualizeConfig } from './swiper-config'

const AdSwiper = React.forwardRef(({
  children,
  params,
  isLazy,
  customButtons,
  getSwiper,
  autoView,
  prevIcon = 'leftArrowSwiper',
  nextIcon = 'rigthArrowSwiper',
  goToSlideNumber = 3,
  isVirtual = false,
  customClasses = ''
}, ref) => {
  const [swiper, setSwiper] = useState({})
  const [swiperButtons, setUpdateButtons] = useState({})
  const lazyConfig = isLazy ? swiperLazyConfig : {}
  const autoViewConfig = autoView ? swiperAutoViewConfig : {}
  const virtualizeProps = { ...virtualizeConfig, 'virtual': { slides: children, ...virtualizeConfig.virtual } }
  const swiperParams = { ...swiperConfig, ...lazyConfig, ...autoViewConfig, ...params, ...(isVirtual ? virtualizeProps : {}) }

  if (isVirtual) {
    SwiperCore.use([Virtual])
  }

  useEffect(() => {
    if (swiper) {
      const { isEnd, isBeginning } = swiper
      setUpdateButtons({ isEnd, isBeginning })

      if (getSwiper) {
        getSwiper(swiper)
      }
    }
  }, [swiper])

  const renderButtons = () => {
    if (customButtons) {
      return customButtons()
    } else if (autoView) {
      return <Fragment>
        {!swiperButtons.isBeginning && renderPrevButton(swiper, prevIcon, setUpdateButtons, goToSlideNumber)}
        {!swiperButtons.isEnd && renderNextButton(swiper, nextIcon, setUpdateButtons, goToSlideNumber)}
      </Fragment>
    }
    return <Fragment>
      {renderPrevButton(swiper, prevIcon)}
      {renderNextButton(swiper, nextIcon)}
    </Fragment>
  }

  return (
    <div className={classnames('ad-swiper', { 'ad-swiper--multiple-slides-per-view': autoView || customButtons }, customClasses)}
      ref={ref}>
      <Swiper onSwiper={swiper => setSwiper(swiper)} slidesPerView={1} {...swiperParams}>
        {children}
      </Swiper>
      {renderButtons()}
    </div>
  )
})

AdSwiper.propTypes = {
  params: object,
  children: node,
  isLazy: bool,
  isVirtual: bool,
  autoView: bool,
  customButtons: func,
  getSwiper: func,
  prevIcon: string,
  nextIcon: string,
  goToSlideNumber: number,
  customClasses: string
}

export default AdSwiper